import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";
import "react-dates/initialize";
import { DateRangePicker } from "react-dates";
import "react-dates/lib/css/_datepicker.css";
import moment from "moment";
import { Row, Card, FormGroup, Label, Form, Input, CustomInput } from "reactstrap";
import Select from "react-select";
import { TimePicker } from "antd";
import SingleDatePickerWrapper from "../../components/common/SingleDatePickerWrapper";
import CustomSelectInput from "../../components/common/CustomSelectInput";
import IntlMessages from "../../helpers/IntlMessages";
import { Colxx } from "../../components/common/CustomBootstrap";
import AddNewRequestModal from "../requests/AddNewRequestModal";
import {
  addBookingItem, invokeBookingKeylessKey, easeeGetAdminUsers
} from "../../redux/booking/actions";
import BookingHeadSection from "../../components/bookingDetailPage/BookingHeadSection";
import BookingLeftSideSection from "../../components/bookingDetailPage/BookingLeftSideSection";
import Loader from "../../components/common/Loader";

class BookingDetailsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false,
      showError: false
    };
  }

  componentDidMount() {
    this.props.easeeGetAdminUsers();
  }

  toggleModal = () => {
    const { modalOpen } = this.state;
    this.setState({
      showError: false,
      modalOpen: !modalOpen
    });
  };

  setShowError = () => {
    this.setState({
      showError: true
    });
  };

  handleNationality = e => {
    const { match, addBookingItem } = this.props;
    const toPatch = { nationality: e.value, id: match.params.id };
    addBookingItem(toPatch);
  };

  handleButler = async e => {
    const { match, addBookingItem } = this.props;
    const toPatch = { butler: e.value, id: match.params.id };
    await addBookingItem(toPatch);
  };

  handleGender = e => {
    const { match, addBookingItem } = this.props;
    const gender = e.target.id;
    const toPatch = { gender, id: match.params.id };
    addBookingItem(toPatch);
  };

  handleTextBox = e => {
    let value = e.target.value.trim();
    const { allBookingItems, match, addBookingItem } = this.props;
    const booking = allBookingItems[match.params.id];
    if (booking[e.target.name] === value) {
      return;
    }
    const toPatch = { [e.target.name]: value, id: match.params.id };
    addBookingItem(toPatch);
  };

  onDatesChange = (startDate, endDate) => {
    const { match, addBookingItem } = this.props;
    try {
      const toPatch = {
        checkin: `${startDate.unix()}`,
        checkout: `${endDate.unix()}`,
        id: match.params.id
      };
      addBookingItem(toPatch);
    } catch (err) {
      console.error("Error in onDatesChange", err);
    }
  };

  handleCheckinHour = (time, checkin) => {
    const checkingTimeStamp = moment(checkin * 1000);
    const checkingSetHours = checkingTimeStamp.set({ hour: `${time.format("HH")}` });
    const { match, addBookingItem } = this.props;
    let toPatch = {};
    try {
      toPatch = {
        checkin: `${checkingSetHours.unix()}`,
        id: match.params.id
      };
      addBookingItem(toPatch);
    } catch (err) {
      console.error("Error in handleCheckinHour", err);
    }
  };

  handleCheckoutHour = (time, checkout) => {
    const checkoutTimeStamp = moment(checkout * 1000);
    const checkoutSetHours = checkoutTimeStamp.set({ hour: `${time.format("HH")}` });
    const { match, addBookingItem } = this.props;
    let toPatch = {};
    try {
      toPatch = {
        checkout: `${checkoutSetHours.unix()}`,
        id: match.params.id
      };
      addBookingItem(toPatch);
    } catch (err) {
      console.error("Error in handleCheckoutHour", err);
    }
  };

  onBirthdateChange = birthdate => {
    const { match, addBookingItem } = this.props;
    try {
      const toPatch = {
        birthday: `${birthdate.unix()}`,
        id: match.params.id
      };
      addBookingItem(toPatch);
    } catch (err) {
      alert(this.getDefinition("birthdate_error", this));
    }
  };

  isOutsideRange = day => moment().diff(day) < 0;

  handleRooms = (room, user_id) => {
    const { match, addBookingItem, invokeBookingKeylessKey } = this.props;
    const toPatch = { rooms: room.split(","), id: match.params.id };
    addBookingItem(toPatch);
    if (user_id) invokeBookingKeylessKey(user_id);
  };

  render() {
    const { focusedInput, showError, modalOpen } = this.state;
    const {
      hotelConfig,
      allBookingItems,
      AdminUserList,
      keyless_active,
      intl: { messages },
      match,
      history,
      loading
    } = this.props;
    const { countryList } = messages;
    const booking = allBookingItems[match.params.id];

    if (!booking) {
      if (loading) return (<Loader />);

      return (
        <div className="text-center">
          <div className="list-item-heading mb-2 text-muted" style={{ fontSize: "25px" }}>
            <i className="iconsminds-information text-muted" />
            <IntlMessages id="booking.wrong_booking_page" />
          </div>
        </div>
      );
    }

    const filteredAdminList = [{ label: "Please Select", value: "" }];
    if (AdminUserList && AdminUserList.body) {
      const userList = AdminUserList.body;
      userList.forEach(user => {
        const res = user.Attributes.filter(userAttr => userAttr.Name === "family_name" && userAttr.Value.toLowerCase() === "butler");
        if (res.length > 0) {
          user.Attributes.forEach(userAttrName => {
            if (userAttrName.Name === "name") {
              filteredAdminList.push({ label: userAttrName.Value, value: userAttrName.Value });
            }
          });
        }
      });
    }

    const formatTime = "HH:mm";
    let currentOption = 0;
    let currentOptionForAdmin = 0;

    // TODO ColorfullDropdown
    for (let i = 0; i < Object.keys(countryList).length; i += 1) {
      if (booking.nationality === countryList[i].value) {
        currentOption = i;
      }
    }

    for (let i = 0; i < Object.keys(filteredAdminList).length; i += 1) {
      if (booking.butler === filteredAdminList[i].value) {
        currentOptionForAdmin = i;
      }
    }

    return (
      <Fragment>
        <Row className="app-row survey-app">
          <Colxx xxs="12">
            <Fragment>
              <BookingHeadSection
                history={history}
                toggleModal={this.toggleModal}
              />
            </Fragment>

            <Fragment>
              <Row>
                <Colxx xxs="12" lg="4">
                  <BookingLeftSideSection
                    booking={booking}
                    match={match}
                  />
                </Colxx>

                <Colxx xxs="12" lg="8">
                  <ul className="list-unstyled mb-4">
                    <li>
                      <Card className="question d-flex mb-4">
                        <div className="d-flex flex-grow-1 min-width-zero">
                          <div
                            className={`card-body align-self-center d-flex flex-column
                              flex-md-row justify-content-between min-width-zero align-items-md-center`}
                          >
                            <div className="list-item-heading mb-0 truncate w-80 mb-1 mt-1" />
                          </div>
                        </div>

                        <div className="card-body pt-0">
                          <div className="edit-mode">
                            <Form>
                              <FormGroup>
                                <Label>
                                  <IntlMessages id="bookingDetails.checkin_checkout" />
                                </Label>

                                <DateRangePicker
                                  isOutsideRange={() => false}
                                  block
                                  small
                                  withPortal
                                  orientation={window.matchMedia("(max-width: 700px)").matches ? "vertical" : "horizontal"}
                                  showDefaultInputIcon
                                  startDate={moment(booking.checkin * 1000)} // momentPropTypes.momentObj or null,
                                  startDateId="your_unique_start_date_id" // PropTypes.string.isRequired,
                                  endDate={moment(booking.checkout * 1000)} // momentPropTypes.momentObj or null,
                                  endDateId="your_unique_end_date_id" // PropTypes.string.isRequired,
                                  onDatesChange={({ startDate, endDate }) => this.onDatesChange(startDate, endDate)} // PropTypes.func.isRequired,
                                  focusedInput={focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                                  onFocusChange={date => this.setState({ focusedInput: date })} // PropTypes.func.isRequired,
                                />
                              </FormGroup>

                              <FormGroup>
                                <Label>
                                  <IntlMessages id="bookingDetails.checkin_checkout_time" />
                                </Label>

                                <div>
                                  <TimePicker
                                    defaultValue={moment(
                                      `${moment(booking.checkin * 1000)
                                        .toDate()
                                        .getHours()}:00`,
                                      formatTime
                                    )}
                                    format={formatTime}
                                    id="checkinTime"
                                    onChange={e => this.handleCheckinHour(e, booking.checkin)}
                                    placeholder=""
                                  />{" "}
                                  -
                                  <TimePicker
                                    defaultValue={moment(
                                      `${moment(booking.checkout * 1000)
                                        .toDate()
                                        .getHours()}:00`,
                                      formatTime
                                    )}
                                    format={formatTime}
                                    id="checkoutTime"
                                    onChange={e => this.handleCheckoutHour(e, booking.checkout)}
                                    placeholder=""
                                  />
                                </div>
                              </FormGroup>

                              <FormGroup>
                                <Label>
                                  {" "}
                                  <IntlMessages id="bookingDetails.room" />
                                </Label>

                                {hotelConfig.keyless_active && keyless_active === true ?
                                  (
                                    <Input
                                      key={booking.rooms ? booking.rooms.join(",") : ["none"]}
                                      type="text"
                                      defaultValue={booking.rooms ? booking.rooms.join(",") : ""}
                                      onBlur={event => {
                                        const val = event.target.value.trim();
                                        if (val !== booking?.rooms?.join(",")) {
                                          this.handleRooms(val, booking.user_id);
                                        }
                                      }}
                                    />
                                  ) : (
                                    <Input
                                      key={booking.rooms ? booking.rooms.join(",") : ["none"]}
                                      type="text"
                                      defaultValue={booking.rooms ? booking.rooms.join(",") : ""}
                                      onBlur={event => {
                                        const val = event.target.value.trim();
                                        if (val !== booking?.rooms?.join(",")) {
                                          this.handleRooms(val);
                                        }
                                      }}
                                    />
                                  )
                                }
                              </FormGroup>

                              <FormGroup>
                                <Label>
                                  {" "}
                                  <IntlMessages id="bookingDetails.national_identification_number" />
                                </Label>

                                <Input
                                  key={booking.national_identification_number}
                                  type="text"
                                  name="national_identification_number"
                                  defaultValue={booking.national_identification_number}
                                  onBlur={this.handleTextBox}
                                />
                              </FormGroup>

                              <FormGroup>
                                <Label>
                                  <IntlMessages id="bookingDetails.nationality" />
                                </Label>

                                <Select
                                  menuPortalTarget={document.body}
                                  styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                  components={{ Input: CustomSelectInput }}
                                  className="react-select"
                                  classNamePrefix="react-select"
                                  name="form-field-name"
                                  value={countryList[currentOption]}
                                  onChange={this.handleNationality}
                                  options={countryList}
                                />
                              </FormGroup>

                              {filteredAdminList.length > 1 && (
                                <FormGroup>
                                  <Label>Butler</Label>
                                  <Select
                                    menuPortalTarget={document.body}
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                    components={{ Input: CustomSelectInput }}
                                    className="react-select"
                                    classNamePrefix="react-select"
                                    name="form-field-name"
                                    value={filteredAdminList[currentOptionForAdmin]}
                                    onChange={this.handleButler}
                                    options={filteredAdminList}
                                  />
                                </FormGroup>
                              )}

                              <FormGroup>
                                <Label>
                                  {" "}
                                  <IntlMessages id="bookingDetails.reservation_number" />
                                </Label>

                                <Input
                                  key={booking.reservation_number}
                                  type="text"
                                  name="reservation_number"
                                  defaultValue={booking.reservation_number}
                                  onBlur={this.handleTextBox}
                                />
                              </FormGroup>

                              <FormGroup>
                                <Label>
                                  {" "}
                                  <IntlMessages id="bookingDetails.passport_number" />
                                </Label>

                                <Input
                                  key={booking.passport_number}
                                  type="text"
                                  name="passport_number"
                                  defaultValue={booking.passport_number}
                                  onBlur={this.handleTextBox}
                                />
                              </FormGroup>

                              <FormGroup>
                                <Label>
                                  <IntlMessages id="bookingDetails.birth_date" />
                                </Label>

                                <div className="dater">
                                  <SingleDatePickerWrapper
                                    small
                                    isOutsideRange={this.isOutsideRange}
                                    displayFormat={messages.birthdate_format}
                                    onDateChangeFunction={(date) =>
                                      date.unix().toString() !== booking.birthday ? this.onBirthdateChange(date) : null
                                    }
                                    id="birthdate"
                                    initialDate={booking.birthday ? moment(booking.birthday * 1000).utcOffset("+12:00") : moment()}
                                    showDefaultInputIcon
                                    withPortal
                                  />
                                </div>
                              </FormGroup>

                              <FormGroup>
                                <Label for="exCustomRadio">
                                  <IntlMessages id="bookingDetails.gender" />
                                </Label>

                                <>
                                  <CustomInput
                                    checked={booking.gender ? booking.gender === "female" : false}
                                    onChange={this.handleGender}
                                    type="radio"
                                    id="female"
                                    name="customRadio"
                                    value="female"
                                    label={messages["bookingDetails.genderFemale"]}
                                  />

                                  <CustomInput
                                    checked={booking.gender ? booking.gender === "male" : false}
                                    onChange={this.handleGender}
                                    type="radio"
                                    id="male"
                                    value="male"
                                    name="customRadio"
                                    label={messages["bookingDetails.genderMale"]}
                                  />
                                </>
                              </FormGroup>

                              <FormGroup>
                                <Label>
                                  {" "}
                                  <IntlMessages id="bookingDetails.tp_id" />
                                </Label>

                                <Input
                                  key={booking.tp_id}
                                  type="text"
                                  name="tp_id"
                                  defaultValue={booking?.tp_id}
                                  onBlur={e =>
                                    (booking?.tp_id || e.target.value.trim()) ? this.handleTextBox(e) : null
                                  }
                                />
                              </FormGroup>
                            </Form>
                          </div>
                        </div>
                      </Card>
                    </li>
                  </ul>
                </Colxx>
              </Row>
            </Fragment>
          </Colxx>

          <AddNewRequestModal
            booking={booking}
            showError={showError}
            toggleModal={this.toggleModal}
            setShowError={this.setShowError}
            modalOpen={modalOpen}
          />
        </Row>
      </Fragment>
    );
  }
}

BookingDetailsContainer.propTypes = {
  settings: PropTypes.object,
  match: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  keyless_active: PropTypes.bool,
  bookingApp: PropTypes.object
};

const mapStateToProps = ({ bookingApp, settings }) => {
  const { hotelConfig } = settings;
  const { allBookingItems, AdminUserList, loading } = bookingApp;
  return { allBookingItems, AdminUserList, hotelConfig, loading };
};

const mapActionsToProps = {
  addBookingItem,
  invokeBookingKeylessKey,
  easeeGetAdminUsers,
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapActionsToProps
  )(BookingDetailsContainer)
);
